//@ts-ignore
import { createEffect, createSignal, onCleanup, For, onMount, createMemo } from "solid-js";
import { View, Text, hexColor, Show, ElementNode } from "@lightningtv/solid";
import { useNavigate, useParams } from "@solidjs/router";
import styles from "../../styles";
import {
  isVpnMode,
  playListPassword,
  playListUrl,
  playListUsername,
  setGlobalBackground,
  setIsPlaying,
  setIsVpnMode,
} from "../../../state";
import { Button, ButtonContainer, Column, Input, Keyboard, Row } from "@lightningtv/solid-ui";
import axios from "axios";
import { assertTruthy } from "@lightningjs/renderer/utils";
import { createInfiniteScroll } from "../../components/pagination";
import { LazyUp } from "@lightningtv/solid/primitives";
import searchSeries from "../../api/providers/searchSeries";
import LoadingIndicator from "../loading/loading";

const layout = [
  ["A", "B", "C", "D", "E", "F"],     // 0
  ["G", "H", "I", "J", "K", "L"],     // 1
  ["M", "N", "O", "P", "Q", "R"],     // 2
  ["S", "T", "U", "V", "W", "X"],     // 3
  ["Y", "Z", "1", "2", "3", "4"],     // 4
  ["5", "6", "7", "8", "9", "0"]      // 5
];

const SearchSeriesPage = () => {
  const refs: Array<Array<any>> = layout.map(() => []);
  const [inputValue, setInputValue] = createSignal("");
  const [isLoading, setIsLoading] = createSignal(true); // Add loading state
  const [hasError, setHasError] = createSignal(false); // Add error state
  let lastFocusedKey = refs[0][0];

  let spaceRef: any, backspaceRef: any, searchRef: any;

  const params = useParams();
  const navigate = useNavigate();

  onMount(() => {
    // Only set focus if not loading and no error
    if (!isLoading() && !hasError()) {
      refs[0][0]?.setFocus?.();
    }
  });

  ////// Search////////////////////////////////////////////
  const [data2, setData2] = createSignal(null);
  const [data, setData] = createSignal(null);

  ////// Search////////////////////////////////////////////
  const providerCategory = createMemo(() => {
    return createInfiniteScroll(
      //@ts-ignore
      searchSeries(params.filter || "all"),
    );
  });

  createEffect(() => {
    try {
      setIsLoading(true);
      setHasError(false); // Reset error state

      const kevi: any = providerCategory().pages();
      if (providerCategory().pages()) {
        //@ts-ignore
        setData(kevi);
        setIsLoading(false);
        setHasError(false);

        // Set focus to first key after loading is complete
        setTimeout(() => {
          refs[0][0]?.setFocus?.();
        }, 100);
      }
    } catch (error) {
      console.error("Error loading series data:", error);
      setIsLoading(false);
      setHasError(true);
    }
  });

  onMount(() => {
    setGlobalBackground("#0A1C34");

    // Initial loading state - will be set to false when data arrives
    setIsLoading(true);

    const storedData = localStorage.getItem("moviesData");
    if (storedData) {
      setData2(JSON.parse(storedData));
    }
  });

  ///Search////////////////////////////////////////
  createEffect(() => {
    localStorage.setItem("searchInput", inputValue());
  });

  onMount(() => {
    const storedInput = localStorage.getItem("searchInput");
    if (storedInput) {
      setInputValue(storedInput);
    }
  });

  const [displayedItems, setDisplayedItems] = createSignal([]);

  const filterData = () => {
    if (!inputValue()) return providerCategory().pages();
    return providerCategory()
      .pages()
      .filter((item: any) => item.title.toLowerCase().includes(inputValue().toLowerCase()));
  };

  // Create an effect to update the displayed items whenever `filterData` changes
  createEffect(() => {
    const filtered: any = filterData();
    setDisplayedItems([]); // Reset list
    setTimeout(() => setDisplayedItems(filtered), 0); // Update list with new data
  });

  let viewRef;
  let row1;

  const titleSignal = createSignal("");
  const keyEvent = createSignal("");
  const [resetLazyUp, setResetLazyUp] = createSignal(false);

  createEffect(() => {
    titleSignal[0](); // React to search input changes
    setResetLazyUp(false); // Remove the component
    setTimeout(() => setResetLazyUp(true), 0); // Re-add the component in the next tick
  });

  createEffect(() => {
    if (data()) {
      console.log('data length ', data().length);
    }
  }, [data()]);

  // Helper function to handle keypad interactions - disabled when loading or error
  const handleKeypadInteraction = (callback: () => void) => {
    if (!isLoading() && !hasError()) {
      callback();
    }
  };

  return (
    <View color={hexColor("#182027")}>
      <View
        width={1920}
        onEscape={() => {
          if (!isLoading()) {
            navigate(-1);
          }
        }}
        height={1700}
        positionAbsolute={0}
        src={"https://i.ibb.co/Lzk5hD4Y/Maskgroup.png"}
      >
        <View src="https://i.ibb.co/ZVmDwNg/logo.png" x={800} y={50} width={270} height={82} />

        <View x={50} y={50}>
          <View src="https://i.ibb.co/LX13T2JW/Group-Live-Tv.png" width={102} height={102} />
          <Text x={120} y={33} fontSize={34} fontWeight={"bold"}>Search</Text>
        </View>

        <View x={1600} y={50}>
          <View
            ref={searchRef}
            x={120}
            style={{
              width: 100,
              height: 100,
              opacity: isLoading() || hasError() ? 0.3 : 1 // Visual feedback when disabled
            }}
            forwardStates style={styles.searchSettingsButton}
            onEnter={() => {
              handleKeypadInteraction(() => navigate("/userInfo"));
            }}
            onDown={() => {
              handleKeypadInteraction(() => backspaceRef.setFocus());
            }}
          >
            <View x={28} y={28} src="https://i.ibb.co/Jjp8bmn4/setting.png" width={42} height={42} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>
        </View>

        {/* Loading Overlay */}
        <Show when={isLoading()}>
          <View
            width={1920}
            height={1700}
            color={hexColor("#000000")}
            alpha={0.7}
            positionAbsolute={0}
            style={{ zIndex: 1000 }}
          >
            <View x={960} y={500}>
              <LoadingIndicator isCategoriesIndicator={false} />
            </View>
          </View>
        </Show>

        {/* Error Overlay */}
        <Show when={hasError()}>
          <View
            width={1920}
            height={1700}
            color={hexColor("#000000")}
            alpha={0.8}
            positionAbsolute={0}
            style={{ zIndex: 1000 }}
          >
            <View x={1160} y={300} style={{ textAlign: 'center' }}>
              {/* Error Icon */}
              <View x={-50} y={0} width={100} height={100}>
                <Text fontSize={80} color={hexColor("#FF6B6B")}>⚠️</Text>
              </View>

              {/* Error Message */}
              <Text
                x={-300}
                y={120}
                fontSize={42}
                color={hexColor("#FFFFFF")}
                fontWeight="bold"
                style={{ textAlign: 'center' }}
              >
                There is a problem at the moment
              </Text>
              <Text
                x={-150}
                y={180}
                fontSize={32}
                color={hexColor("#CCCCCC")}
                style={{ textAlign: 'center' }}
              >
                Please try again later
              </Text>


            </View>
          </View>
        </Show>

        <View style={{ opacity: isLoading() || hasError() ? 0.3 : 1 }}>
          {/* Input Text Display */}
          <View x={100} y={220} style={styles.containerText}>
            <Text fontSize={48} x={20} y={15}>{inputValue()}</Text>
          </View>

          {/* Space Key */}
          <View
            ref={(el) => (spaceRef = el)}
            x={100}
            y={310}
            forwardStates style={styles.searchSpace}
            onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev + " "))}
            onDown={() => handleKeypadInteraction(() => refs[0][0]?.setFocus())}
            onRight={() => handleKeypadInteraction(() => backspaceRef.setFocus())}
            onUp={() => handleKeypadInteraction(() => searchRef.setFocus())}
          >
            <View src={"https://i.ibb.co/G4SDmcq9/space.png"} width={100} height={80} x={80} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>

          {/* Backspace Key */}
          <View
            ref={(el) => (backspaceRef = el)}
            x={360}
            y={310}
            forwardStates style={styles.searchSpace}
            onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev.slice(0, -1)))}
            onDown={() => handleKeypadInteraction(() => refs[0][0]?.setFocus())}
            onLeft={() => handleKeypadInteraction(() => spaceRef.setFocus())}
            onUp={() => handleKeypadInteraction(() => searchRef.setFocus())}
          >
            <View src={"https://i.ibb.co/wh6n5N3X/backspace.png"} width={70} height={60} y={10} x={100} style={{ color: "#ffffff", focus: { color: "#000000" } }} />
          </View>

          {/* Character Keys */}
          <View x={100} y={400}>
            {layout.map((row, rowIndex) => (
              <View y={rowIndex * 85}>
                {row.map((char, colIndex) => (
                  <View
                    ref={(el) => {
                      refs[rowIndex][colIndex] = el;
                      el.onFocus = () => {
                        if (!isLoading() && !hasError()) {
                          lastFocusedKey = el;
                        }
                      };
                    }}
                    forwardStates style={styles.buttonKey}
                    x={colIndex * 85}
                    onEnter={() => handleKeypadInteraction(() => setInputValue(prev => prev + char))}
                    onRight={() => {
                      handleKeypadInteraction(() => {
                        const next = refs[rowIndex][colIndex + 1];
                        if (next) {
                          next.setFocus();
                        } else {
                          viewRef?.setFocus();
                        }
                      });
                    }}
                    onLeft={() => {
                      handleKeypadInteraction(() => {
                        const prev = refs[rowIndex][colIndex - 1];
                        if (prev) prev.setFocus();
                      });
                    }}
                    onDown={() => {
                      handleKeypadInteraction(() => {
                        const down = refs[rowIndex + 1]?.[colIndex];
                        if (down) down.setFocus();
                      });
                    }}
                    onUp={() => {
                      handleKeypadInteraction(() => {
                        if (rowIndex === 0) {
                          spaceRef?.setFocus();
                        } else {
                          const up = refs[rowIndex - 1]?.[colIndex];
                          if (up) up.setFocus();
                        }
                      });
                    }}
                  >
                    <Text fontSize={40} x={25} y={25} style={{ color: "#ffffff", focus: { color: "#000000" } }}>{char}</Text>
                  </View>
                ))}
              </View>
            ))}
          </View>
        </View>

        <Text fontSize={38} x={750} y={230}>Series</Text>

        <View y={300} x={750} clipping gap={20}>
          <Show
            when={!isLoading() && !hasError() && providerCategory().pages().length > 0}
            fallback={
              <Show when={isLoading()}>
                <View x={1350} y={100}>
                  <LoadingIndicator isCategoriesIndicator={false} />
                </View>
              </Show>
            }
          >
            <Show when={!isLoading() && !hasError() && displayedItems().length === 0}>
              <Text x={1350} fontSize={30}>No series found</Text>
            </Show>
            <Show when={resetLazyUp()}>
              {/* @ts-ignore */}
              <LazyUp
                component={Row}
                onLeft={() => handleKeypadInteraction(() => lastFocusedKey?.setFocus())}
                ref={viewRef}
                scroll="always"
                direction="row"
                upCount={8}
                each={displayedItems()}
              >
                {(item: any) => (
                  <View
                    onEnter={() => {
                      handleKeypadInteraction(() => {
                        navigate(`/serieDetails/series/${item().stream_id}/${item().category_id}`);
                      });
                    }}
                    x={950}
                    style={styles.searchResultItem}
                  >
                    <View
                      x={7}
                      y={7}
                      borderRadius={10}
                      width={244}
                      height={390}
                      src={item().image_stream}
                    ></View>
                    <Text style={{ fontSize: 23 }} y={420}>
                      {item().title.length > 22 ? `${item().title.slice(0, 22)}...` : item().title}
                    </Text>
                  </View>
                )}
              </LazyUp>
            </Show>
          </Show>
        </View>
      </View>
    </View>
  );
};

export default SearchSeriesPage;